module.exports = __webpack_public_path__ + "static/img/sdyc11.f3f09f89.png";